import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import ticket from "../../../../../assets/images/icons/icn-voucher.png";
import creditBear from "../../../../../assets/images/icons/icn-creditGrey.png";
import cleanproCreditIcon from "../../../../../assets/images/icons/icn-credit.png";

import { currency } from "../../../../../dynamicController";

const CleanproVending = ({ amount, setAmount, machine, minusAmount, addAmount, handleSubmit, user, discountCode, voucherId, setDiscountCodeModal, setOpen, point, setPoint, voucherDiscountAmount, discountText, discountCodeDiscountAmount, getPaymentAmount, isOpen, removeVoucher, renderVouchers, useVoucher }) => {

    const { t } = useTranslation();
    const history = useHistory();

    return (
        <div>
            <div className="payment-section">
                <h6 style={{ margin: "20px 0 5px 0" }}>
                    <strong>{t("Select Payment Amount")}</strong>
                </h6>

                <div className="custom-duration mt-2">
                    <p id="cleanpro-minus-amount" onClick={(e) => minusAmount()}>-</p>
                    <div>
                        {
                            machine.type === "Billacceptor" ? (
                                <div className="d-flex">
                                    <h3 style={{ marginTop: "auto", marginBottom: "auto" }}>{currency(machine.country)}</h3>
                                    <input type="number" id="amount" name="amount" className="ms-2 form-control browser-default text-center" value={amount} onChange={e => setAmount(e.target.value)} required min="0" max="100" step={machine.step || 1} />
                                </div>
                            ) : (
                                <h3 style={{ marginTop: "auto", marginBottom: "auto" }}>
                                    {currency(machine.country)} {/\./g.test(amount.toString()) ? parseFloat(amount).toFixed(2) : amount}
                                </h3>
                            )
                        }
                    </div>
                    <p id="cleanpro-add-amount" onClick={(e) => addAmount()}>+</p>
                </div>
            </div>

            <div className="payment-section">
                {
                    user && (machine.type === "Vending Machine" || machine.type === "Detergent Vending" || machine.type === "Car Wash") ? (
                        <div>
                            {
                                (discountCode || !voucherId) ? (
                                    <div
                                        id="cleanpro-input-discountcode"
                                        onClick={(e) => setDiscountCodeModal(true)}
                                        className="checkout-payment py-2"
                                    >
                                        <i className="bi bi-percent text-center" style={{ width: "32px" }}></i>
                                        <p className="ml-1">
                                            {discountCode ? discountCode : t("Discount Code")}
                                        </p>
                                        <p>
                                            <i className="arrow right"></i>
                                        </p>
                                    </div>
                                ) : null
                            }

                            {
                                (voucherId || !discountCode) ? (
                                    <div
                                        id="cleanpro-select-voucher"
                                        onClick={(e) => setOpen(true)}
                                        className="checkout-payment py-2"
                                    >
                                        <img
                                            className="fit-contain"
                                            style={{ width: "32px" }}
                                            src={ticket}
                                            alt=""
                                        />
                                        <p className={`ml-1 ${voucherId && "font-weight-bold"}`}>
                                            {voucherId ? t("1 voucher selected") : t("No voucher selected")}
                                        </p>
                                        <p>
                                            <i className="arrow right"></i>
                                        </p>
                                    </div>
                                ) : null
                            }
                        </div>
                    ) : null
                }
                {
                    user && user.loyalty_point && (machine.type === "Vending Machine" || machine.type === "Detergent Vending" || machine.type === "Car Wash") ? (
                        <div id="cleanpro-point" className="d-flex justify-content-between py-2">
                            <div className="d-flex align-items-center">
                                <img style={{ width: "32px" }} src={cleanproCreditIcon} alt="" />
                                <p className="ml-1">
                                    {user.point} {user.loyalty_point_name}
                                </p>
                            </div>
                            <div className="toggle-switch">
                                <input type="checkbox" className="toggle-switch-checkbox" name="point" id="point" checked={point} onChange={e => setPoint(!point)} />
                                <label className="toggle-switch-label" htmlFor="point">
                                    <span className="toggle-switch-inner" />
                                    <span className="toggle-switch-switch" />
                                </label>
                            </div>
                        </div>
                    ) : null
                }
                {
                    user && user.tokenSetting ? (
                        <div
                            id="cleanpro-reload-token"
                            onClick={() => history.push("/user/reload")}
                            className="checkout-payment py-2"
                        >
                            <img style={{ width: "32px" }} src={creditBear} alt="" />
                            <p className="ml-1">
                                {user.token} {t("credits")}
                            </p>
                            <p>
                                <i className="arrow right"></i>
                            </p>
                        </div>
                    ) : null
                }
                {
                    user ? <div style={{ border: "1px solid #f2f2f2", margin: "5px -20px" }}></div> : null
                }

                {voucherDiscountAmount && (
                    <div className="py-2 d-flex justify-content-between">
                        <h6>{t("Voucher Offers")}</h6>
                        <h6 style={{ color: "#333333" }}>-{discountText("Voucher")}</h6>
                    </div>
                )}

                {discountCodeDiscountAmount && (
                    <div className="py-2 d-flex justify-content-between">
                        <h6>{t("Discount Code Offers")}</h6>
                        <h6 style={{ color: "#333333" }}>-{discountText("Discountcode")}</h6>
                    </div>
                )}

                {point && (
                    <div className="py-2 d-flex justify-content-between">
                        <h6>{user.loyalty_point_name}</h6>
                        <h6 style={{ color: "#333333" }}>-{getPaymentAmount("pointAmount")} {user.loyalty_point_name} ({!user.tokenSetting ? currency(machine.country) : ""} {getPaymentAmount("pointValue")} {user.tokenSetting ? t("credit") : ""})</h6>
                    </div>
                )}

                <div className="d-flex justify-content-between py-2">
                    <h6>{t("Amount to Pay")}</h6>
                    <h6 className="font-weight-bold blue-t">
                        {user && user.tokenSetting ? "" : currency(machine.country)} {getPaymentAmount("paymentAmount")} {user && user.tokenSetting ? t("credits") : ""}
                    </h6>
                </div>
            </div>

            <div className="mt-5 px-3">
                <button id="pay" onClick={e => handleSubmit(e)} className="btn form-control big-button">
                    {t("Pay now")}
                </button>
            </div>

            {user ? (
                <div>
                    <div
                        onClick={(e) => setOpen(false)}
                        className={isOpen ? "custom-overlay isOpen" : "custom-overlay"}
                    ></div>
                    <div className={isOpen ? "custom-modal isOpen" : "custom-modal"}>
                        <div className="custom-modal-header">
                            {voucherId ? (
                                <button
                                    id="remove-voucher"
                                    onClick={(e) => removeVoucher()}
                                    type="button"
                                    className="custom-modal-title m-0 p-0"
                                    style={{
                                        color: "red",
                                        border: "none",
                                        backgroundColor: "white",
                                        margin: 0,
                                        padding: 0,
                                    }}
                                >
                                    <i className="bi bi-slash-circle"></i> {t("Remove Voucher")}
                                </button>
                            ) : (
                                <h6 className="custom-modal-title">
                                    {t("Select voucher to use")}
                                </h6>
                            )}
                        </div>

                        <div className="custom-modal-body">
                            <ul className="list-group list-group-flush px-4">
                                {renderVouchers()}
                            </ul>
                        </div>
                        <button onClick={useVoucher} className="btn big-button" style={{ width: "90%" }}>
                            {t("Use voucher")}
                        </button>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default CleanproVending;